import { type Ref, computed } from 'vue';

import { REMAPPABLE_ACCOUNT_FIELDS } from '@/constants/field_mapping';

export const EXCLUDED_SYSTEM_COLUMNS = [
  'File Name',
  'Upload Time',
  'id',
  'createdAt',
  'created_at',
];

type SourceField = {
  mdm_property: string | null;
  is_visible?: boolean;
  column: string;
};

export default function useFieldMappingVisibility(
  fields: Ref<SourceField[]>,
  allowedMdmProperties?: Ref<string[]>,
) {
  const displayMapFieldsButton = computed(() => {
    const remappableFields = allowedMdmProperties
      ? REMAPPABLE_ACCOUNT_FIELDS.filter((field) =>
          allowedMdmProperties.value.includes(field.mdmProperty),
        )
      : REMAPPABLE_ACCOUNT_FIELDS;
    const sourceFields = fields.value;
    const mappedProps = new Set(
      sourceFields
        .filter((f) => f.mdm_property !== null)
        .map((f) => f.mdm_property),
    );
    const hasMappedOptionalFields = remappableFields.some((field) =>
      mappedProps.has(field.mdmProperty),
    );
    const hasUnmappedColumns = sourceFields.some(
      (field) =>
        field.is_visible &&
        field.mdm_property === null &&
        !EXCLUDED_SYSTEM_COLUMNS.includes(field.column),
    );
    const hasUnmappedOptionalFields = remappableFields.some(
      (field) => !mappedProps.has(field.mdmProperty),
    );
    return (
      hasMappedOptionalFields ||
      (hasUnmappedColumns && hasUnmappedOptionalFields)
    );
  });

  return { displayMapFieldsButton };
}
